<mbs-modal
  #modal
  class="buy-premium-support-modal"
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'shared:licenses.buyPremiumSupportModal.title' | i18next">
  <div modal-body>
    <div class="premium-cards d-flex flex-wrap">
      @for (feature of features; track feature.id) {
        <div
          class="premium-card"
          [ngClass]="feature.cardClass">
          <span
            class="premium-card__icon"
            [ngClass]="feature.iconClass"></span>
          <div class="premium-card__label">
            {{ feature.label | i18next }}
          </div>
        </div>
      }
    </div>

    <div class="premium-summary d-flex align-items-center justify-content-center mt-4 p-3">
      @if (pricesLoading()) {
        <mbs-loader
          [size]="'xsmall'"
          [useFixedSize]="true"></mbs-loader>
      } @else {
        <div class="premium-summary__price text-center">
          <div>
            <span class="text-lg fw-bold">${{ pricePerLicense() | number: '1.2-2' }}</span>
            <span class="text-muted">&nbsp;{{ periodLabelKey() | i18next }}</span>
          </div>
          <div class="text-xs text-muted">
            {{ 'shared:licenses.buyPremiumSupportModal.proratedNote' | i18next }}
          </div>
          <div class="text-xs text-muted">
            {{ 'shared:licenses.buyPremiumSupportModal.fullPriceNote' | i18next }}
          </div>
        </div>
      }
    </div>
  </div>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="pricesLoading()"
      [loading]="loading()"
      (click)="submit()">
      {{ submitLabelKey() | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="cancel()">
      {{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
